module.exports = __webpack_public_path__ + "static/media/CertificadoIngles.cc056bfd.jpeg";